import { SimpleGuard } from 'interfaces/guards'
import {
  GetCCStateAction,
  GetCCPaymentMethodsAction,
  GetCCPaymentsAction,
  GetCCUpcomingPaymentsAction,
  GetCCOnboardingStateAction,
} from 'components/features/creditCard/creditCardStore/actions'


export const ccStateGuard: SimpleGuard = {
  name: `Credit Card State Guard`,
  checker: (state) => {
    return state.data.creditCard.onboarding !== null
  },
  loader: (dispatch) => {
    dispatch(new GetCCStateAction())
    dispatch(new GetCCOnboardingStateAction())
    dispatch(new GetCCUpcomingPaymentsAction())
    dispatch(new GetCCPaymentsAction())
    dispatch(new GetCCPaymentMethodsAction())
  },
}
